import React, { useState } from "react";
import "./HeaderTable2.css";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import SearchForum from "./SearchForum";
import AddIcon from "@material-ui/icons/Add";
import Dialog from "@material-ui/core/Dialog";
// import TopicForm from "../../components/forms/TopicForms";
import { Typography, Snackbar } from "@material-ui/core";
import { saveTopic } from "../../services/posts";
import { Alert } from "@mui/material";
import { saveAttachments } from "../../services/attachments";

const HeaderTable = ({ getforumCategories }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Set the default severity to "success"

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <div className="HeaderTables">
      <div className="HeaderTablesDiv1">
        <button className="HeaderTablesDiv1Btn">
          <div className="textStyle">All Categories</div>
          <ArrowRightIcon />
        </button>

        <button className="HeaderTablesDiv1Btn">
          <div className="textStyle">All Topics</div>
          <ArrowRightIcon />
        </button>
      </div>

      <div className="HeaderTablesDiv2">
        <div className="HeaderTablesDiv2Text">Recent</div>
        <div className="HeaderTablesDiv2Text">Top</div>
        <div className="HeaderTablesDiv2Btn">
          <div className="catText">Categories</div>
        </div>
        <div className="HeaderTablesDiv2Text">Docs</div>
      </div>

      <div className="HeaderTablesDiv3">
        <SearchForum />
      </div>

      {/* Snackbar to display success or error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000} // Adjust as needed
        onClose={handleSnackbarClose}
      >
        <Alert
          elevation={6}
          variant="filled"
          severity={snackbarSeverity}
          onClose={handleSnackbarClose}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default HeaderTable;
